// Delivery slots on the admin Orders page: which slot options to offer, and
// how to name and colour a slot.
//
// The options come from the store's own delivery windows (Morning, Evening —
// or whatever the store named them), never from a fixed list, plus any slot
// that is actually saved on orders in view but is not a window any more (for
// example a subscription saved for "both" slots). The value sent to the
// server is the slot as saved on the order, lower-cased; the server matches
// it exactly (routes_admin/operations.list_orders `slot`), so an order is
// never placed in a slot by the time it was created.

export const ALL_SLOTS = "";

const FALLBACK = ["morning", "evening"];

/** "morning" → "Morning", "both" → "Both slots". */
export function slotLabel(slot) {
  const s = String(slot || "").trim().toLowerCase();
  if (!s) return "—";
  if (s === "both") return "Both slots";
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Tailwind classes for a slot badge: morning warm, evening dark, others neutral. */
export function slotTone(slot) {
  const s = String(slot || "").trim().toLowerCase();
  if (s === "morning") return "bg-amber-100 text-amber-800";
  if (s === "evening") return "bg-indigo-100 text-indigo-800";
  return "bg-neutral-100 text-neutral-700";
}

/** [{value, label, count}] — "All slots" first, then the store's windows in
 *  their own order, then any other slot saved on the orders counted in
 *  `slotCounts` ({slot: n} from the server). */
export function slotOptions(windows, slotCounts = {}) {
  const fromWindows = (windows || [])
    .filter((w) => w && w.is_active !== false && String(w.label || "").trim())
    .map((w) => String(w.label).trim().toLowerCase());
  const values = [];
  for (const v of (fromWindows.length ? fromWindows : FALLBACK)) if (!values.includes(v)) values.push(v);
  for (const v of Object.keys(slotCounts || {}).map((k) => k.toLowerCase()).sort()) {
    if (v && !values.includes(v) && (slotCounts[v] || 0) > 0) values.push(v);
  }
  const total = Object.values(slotCounts || {}).reduce((a, n) => a + (Number(n) || 0), 0);
  return [
    { value: ALL_SLOTS, label: "All slots", count: total },
    ...values.map((v) => ({ value: v, label: slotLabel(v), count: Number((slotCounts || {})[v]) || 0 })),
  ];
}
